import React, { ReactElement } from "react";
import "./ImageAlbum.css";

export interface ImageAlbumProps {
    frontImage: string;
    albumName: string;
    uniqueAlbumNumber?: number;
    images?: string[];
    wrapperClasses?: string;
}

export const ImageAlbum = (props: ImageAlbumProps): ReactElement => {
    const frontImage = props.frontImage;
    const albumName = props.albumName;

    const wrapperClasses = props.wrapperClasses ? props.wrapperClasses : "";

    return (
        <div className={`relative md:w-full h-100 w-10rem ${wrapperClasses}`}>
            <p
                className={
                    "absolute bg-white-alpha-90 p-2 left-0 right-0 bottom-0 m-0 vertical-align-middle"
                }
            >
                {albumName}
            </p>
            <img
                src={frontImage}
                style={{
                    margin: 0,
                    padding: 0,
                    height: "100%",
                    width: "100%",
                    display: "block"
                }}
            ></img>
        </div>
    );
};
